import { Reveal } from './motion.jsx';
import styles from './ProcessStep.module.css';

/**
 * One of the five named stages. The heading is an h2 — these are the page's
 * top-level sections, and the previous markup used an h3 styled to look
 * like an h1, which read to a screen reader as a level that wasn't there.
 */
export function ProcessStep({ id, num, title, meta, children }) {
  return (
    <Reveal id={id} className={styles.step}>
      <span className={styles.num}>{num}</span>
      <div>
        <h2 className={styles.title}>{title}</h2>
        <p>{children}</p>
        <span className={styles.meta}>{meta}</span>
      </div>
    </Reveal>
  );
}
